import { render, staticRenderFns } from "./WidgetPreview.vue?vue&type=template&id=32ab426d&scoped=true"
import script from "./WidgetPreview.vue?vue&type=script&lang=js"
export * from "./WidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./WidgetPreview.vue?vue&type=style&index=0&id=32ab426d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab426d",
  null
  
)

export default component.exports